module.exports = __webpack_public_path__ + "static/media/join-the-duel-from-lobby.31643f64.gif";